import { Color } from '@persona-id/design-tokens';
import { FC } from 'react';
import styled from 'styled-components';

import Tooltip from 'design-system/components/Tooltip';

export enum Variant {
  Primary = 'primary',
  Secondary = 'secondary',
  InProgress = 'in-progress',
  Error = 'error',
  ErrorSecondary = 'error-secondary',
}

const TotalIntervalContainer = styled.div`
  position: relative;
  height: 24px;
  width: 100%;

  background-color: transparent;
`;

const Interval = styled.div<{
  startAtFraction: number;
  intervalFraction: number;
  minIntervalFraction: number;
  variant: Variant;
}>`
  position: absolute;
  display: inline-block;
  height: 100%;
  left: ${({ startAtFraction }) => startAtFraction * 100}%;
  width: ${({ intervalFraction, minIntervalFraction }) =>
    Math.max(minIntervalFraction, intervalFraction) * 100}%;

  background-color: ${({ variant, theme }) => {
    return variant === Variant.Primary
      ? theme.color.primary.brand700
      : variant === Variant.Secondary
        ? theme.color.primary.brand200
        : variant === Variant.InProgress
          ? theme.color.variants.basic.highlightDark
          : variant === Variant.Error
            ? theme.color.variants.danger.active
            : Color.BackgroundLabelRedHover;
  }};
`;

interface TimelineProgressBarProps {
  start: number;
  length: number;
  variant: Variant;
  minLengthFraction: number;
  tooltip?: React.ReactNode;
}

export const TimelineProgressBar: FC<TimelineProgressBarProps> = ({
  start,
  length,
  minLengthFraction,
  variant,
  tooltip,
}) => {
  return (
    <TotalIntervalContainer>
      {start >= 0 && length > 0 && start + length <= 1 && (
        <Tooltip
          disabled={!tooltip}
          trigger={
            <Interval
              role='meter'
              aria-label={`Occupies ${length * 100}% of the total time`}
              startAtFraction={start}
              intervalFraction={length}
              minIntervalFraction={minLengthFraction}
              variant={variant}
            />
          }
          side='top'
        >
          {tooltip}
        </Tooltip>
      )}
    </TotalIntervalContainer>
  );
};
